import { render, staticRenderFns } from "./Toasters.vue?vue&type=template&id=2255a09c&lang=html&"
import script from "./Toasters.vue?vue&type=script&lang=js&"
export * from "./Toasters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports